import React from 'react'
import Tooltip from './Tooltip'
import { FIELD_TOOLTIPS } from '../utils/fieldTooltips'

export default function ProcesamientoInfoPanel({
  reviewTab, scoreCertezaInforme, modoHerramienta, asistidoMode,
  shadowBilling, CORE_RULES_CONFIG,
  shadowTopConflicts, setSelectedConflictCuit, setReviewTab,
  selectedConflictCuit,
  shadowResumenMeta, manualResumenTotalesDraft,
  updateManualResumenRow, addManualResumenRow,
  applyManualResumenTotales, conciliacionManualActa,
  periodosResumenControl, downloadProcessingLog, processingPayloadAt,
}) {
  return (
    <>
      <div className="panel-profile-accent mt-2 rounded-lg px-2 py-1 text-xs text-profile-accent">
        {asistidoMode ? (
          <Tooltip text={FIELD_TOOLTIPS.scoreCerteza.tooltipText}>Score de Certeza</Tooltip>
        ) : 'Score de Certeza'}: {scoreCertezaInforme.confianzaInforme}% | FACTUAL: {scoreCertezaInforme.factual} | INFERRED: {scoreCertezaInforme.inferred} | CORRUPT: {scoreCertezaInforme.corrupt}
      </div>
      {scoreCertezaInforme.notaTecnica && (
        <div className="panel-profile-warn mt-2 rounded-lg px-2 py-1 text-xs text-profile-warn">
          {scoreCertezaInforme.notaTecnica}
        </div>
      )}
      {modoHerramienta === 'avanzado' && (
        <div className={`mt-3 rounded-lg p-2 text-xs ${shadowBilling?.enabled && shadowBilling.hasDiscrepancy ? 'panel-profile-danger text-profile-danger' : shadowBilling?.enabled ? 'panel-profile-ok text-profile-ok' : 'panel-profile-warn text-profile-warn'}`}>
          {!shadowBilling?.enabled
            ? `Shadow Billing no verificable: ${shadowBilling?.nonVerifiableReason || 'ausencia de totales monetarios confiables en origen'}.`
            : shadowBilling.hasDiscrepancy
              ? `Alerta Shadow Billing: se detectaron discrepancias entre resumen y detalle. Desbalance global ${Number(shadowBilling.desbalanceGlobal?.diferenciaPct || 0).toFixed(3)}% (umbral ${Number(shadowBilling.thresholdPct || CORE_RULES_CONFIG.desbalanceThresholdPct).toFixed(3)}%).`
              : `Shadow Billing OK: resumen y detalle alineados dentro del umbral ${Number(shadowBilling.thresholdPct || CORE_RULES_CONFIG.desbalanceThresholdPct).toFixed(3)}%.`}
        </div>
      )}
      {modoHerramienta === 'avanzado' && (
        <div className="mt-2 rounded-lg border border-slate-300/30 bg-slate-800/40 p-2 text-xs text-slate-100">
          <p className="font-semibold text-profile-accent">Card de Integridad</p>
          <p className="mt-1">
            Estado: {!shadowBilling?.enabled
              ? 'No verificable (sin base monetaria origen)'
              : shadowBilling.hasDiscrepancy
                ? 'Con desbalances detectados'
                : 'Conciliado'}
          </p>
          {shadowBilling?.enabled && (
            <p className="mt-1 text-slate-300">Desbalance global: {Number(shadowBilling.desbalanceGlobal?.diferenciaPct || 0).toFixed(3)}%</p>
          )}
          {shadowTopConflicts.length > 0 && (
            <div className="mt-2">
              <p className="text-profile-danger">Top 3 CUITs a revisar:</p>
              <ul className="mt-1 space-y-1">
                {shadowTopConflicts.map((c) => (
                  <li key={`shadow-${c.cuit}`} className="panel-profile-danger rounded px-2 py-1">
                    <button type="button" onClick={() => { setSelectedConflictCuit(String(c.cuit || '').replace(/\D/g, '')); setReviewTab('edicion') }} className="text-left">
                      {c.cuit} - {Number(c.diferenciaPct || 0).toFixed(3)}%{c.requiereRevisionUrgente ? ' (Urgente)' : ''} [Ir a filas]
                    </button>
                  </li>
                ))}
              </ul>
              {selectedConflictCuit && (
                <button type="button" onClick={() => setSelectedConflictCuit('')} className="mt-2 rounded border border-white/25 px-2 py-1 text-[11px] text-white">Limpiar filtro CUIT</button>
              )}
            </div>
          )}
          {!shadowBilling?.enabled && (CORE_RULES_CONFIG?.resumenMinConfidence != null) && Number(shadowResumenMeta.sourceConfidence || 0) < CORE_RULES_CONFIG.resumenMinConfidence && (
            <div className="panel-profile-warn mt-2 rounded p-2 text-profile-warn">
              <p>Resumen ANSES con baja confianza ({Number(shadowResumenMeta.sourceConfidence || 0).toFixed(2)}). Carga/valida manualmente los totales por CUIT para habilitar conciliacion.</p>
              {shadowResumenMeta.qualityWarning && <p className="mt-1 text-[11px] text-profile-warn">Detalle parser: {shadowResumenMeta.qualityWarning}</p>}
              <div className="mt-2 overflow-x-auto">
                <table className="min-w-full text-[11px]">
                  <thead>
                    <tr className="text-left text-profile-warn">
                      <th className="px-2 py-1">CUIT</th>
                      <th className="px-2 py-1">Total resumen</th>
                      <th className="px-2 py-1">Motivo</th>
                      <th className="px-2 py-1">Evidencia fuente</th>
                    </tr>
                  </thead>
                  <tbody>
                    {manualResumenTotalesDraft.map((r, i) => (
                      <tr key={`resumen-manual-${i}`}>
                        <td className="px-2 py-1"><input type="text" value={r.cuit} onChange={(e) => updateManualResumenRow(i, 'cuit', e.target.value.replace(/\D/g, ''))} className="h-8 w-40 rounded border border-white/20 bg-slate-900/60 px-2 text-white" /></td>
                        <td className="px-2 py-1"><input type="text" inputMode="decimal" value={r.total} onChange={(e) => updateManualResumenRow(i, 'total', e.target.value)} className="h-8 w-40 rounded border border-white/20 bg-slate-900/60 px-2 text-white" /></td>
                        <td className="px-2 py-1">
                          <select value={r.motivo || ''} onChange={(e) => updateManualResumenRow(i, 'motivo', e.target.value)} className="h-8 w-52 rounded border border-white/20 bg-slate-900/60 px-2 text-white">
                            <option value="">Seleccionar motivo</option>
                            <option value="Error de OCR">Error de OCR</option>
                            <option value="Aporte no registrado en Sabana">Aporte no registrado en Sabana</option>
                            <option value="Sueldo proyectado">Sueldo proyectado</option>
                          </select>
                        </td>
                        <td className="px-2 py-1"><input type="text" value={r.evidenciaFuente || ''} placeholder="Pagina X / tabla Y" onChange={(e) => updateManualResumenRow(i, 'evidenciaFuente', e.target.value)} className="h-8 w-52 rounded border border-white/20 bg-slate-900/60 px-2 text-white" /></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="mt-2 flex flex-wrap gap-2">
                <button type="button" onClick={addManualResumenRow} className="rounded border border-white/25 px-2 py-1 text-[11px] text-white">Agregar CUIT</button>
                <button type="button" onClick={() => applyManualResumenTotales(manualResumenTotalesDraft)} className="btn-profile-soft rounded px-2 py-1 text-[11px]">Aplicar conciliacion manual</button>
              </div>
              {conciliacionManualActa?.hashIntegridad && (
                <p className="mt-2 text-[11px] text-profile-accent">Hash de Integridad: {conciliacionManualActa.hashIntegridad}</p>
              )}
            </div>
          )}
        </div>
      )}
      <div className="mt-2 rounded-lg border border-white/15 bg-slate-900/50 p-2 text-xs text-slate-200">
        <p className="font-semibold text-profile-accent">Control de periodos (Resumen vs Detalle)</p>
        {!periodosResumenControl.available ? (
          <p className="mt-1">No verificable en este PDF (sin bloque de resumen de periodos).</p>
        ) : (
          <>
            <p className="mt-1">Tramos evaluados: {periodosResumenControl.total} | Consistentes: {periodosResumenControl.consistentes} | Con brecha: {periodosResumenControl.conBrecha}</p>
            {periodosResumenControl.topBrechas.length > 0 && (
              <div className="mt-1">
                {periodosResumenControl.topBrechas.map((b) => (
                  <p key={`brecha-${b.cuit}-${b.razonSocial}`}>{b.cuit} - {b.razonSocial}: {b.missingCount} meses sin respaldo en detalle</p>
                ))}
              </div>
            )}
          </>
        )}
      </div>
      <div className="mt-2 rounded-lg border border-white/15 bg-white/5 px-2 py-1 text-[11px] text-slate-200">
        Leyenda: FACTUAL=CUIT validado | INFERRED=CUIT heredado | CORRUPT=CUIT invalido/sin recuperar | rojo=missing en origen.
      </div>
      <div className="mt-2 rounded-lg border border-white/15 bg-slate-900/50 p-3">
        <div className="flex flex-wrap items-center justify-between gap-2">
          <p className="text-xs text-slate-200">Descargable tecnico del procesamiento del caso (.log)</p>
          <button type="button" onClick={downloadProcessingLog} className="rounded border border-white/25 bg-white/10 px-2 py-1 text-[11px] font-semibold text-white">
            Descargar log del procesamiento
          </button>
        </div>
        {processingPayloadAt && (
          <p className="mt-1 text-[11px] text-slate-400">Ultima carga registrada: {new Date(processingPayloadAt).toLocaleString('es-AR', { hour12: false })}</p>
        )}
      </div>
    </>
  )
}
